class TextSearch {
  constructor() {
    this.init();
  }

  init() {
    this.initFormFields();

    if (window.location.search.indexOf('search=') !== -1) {
      this.initSearchFromURL();
    }
  }

  initFormFields() {
    const searchInput = document.getElementById('text-search');
    if (searchInput) {
      const targetUrl = searchInput.dataset.targetUrl;
      const searchContainer = searchInput.dataset.searchContainer;
      if (searchContainer) {
        searchInput.addEventListener('input', (e) => {
          const searchText = e.target.value;
          this.search(searchContainer, searchText);
          e.target.parentNode.querySelector('.reset__button').classList.toggle('hidden', searchText.length === 0);
        });
        searchInput.parentNode.querySelector('.reset__button').addEventListener('click', (e) => {
          searchInput.value = '';
          e.target.classList.add('hidden');
          this.search(searchInput.dataset.searchContainer, '');
        });
      }

      const submitSearchForm = (() => {
        const query = searchInput.value.trim();
        if (!query) return;

        if (targetUrl) {
          window.location.href = targetUrl + '?search=' + encodeURIComponent(query);
        } else if (searchContainer) {
          const el = document.querySelector(searchContainer);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
          }
        }

        if (!targetUrl) {
          window.location.href = '/search?q=' + encodeURIComponent(query);
        }
      });

      searchInput.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          submitSearchForm();
        }
      });
      searchInput.parentNode.querySelector('.search__button').addEventListener('click', submitSearchForm);
    }
  }

  initSearchFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const searchText = urlParams.get('search');
    const searchInput = document.getElementById('text-search');
    if (searchInput) {
      searchInput.value = searchText;
      this.search(searchInput.dataset.searchContainer, searchText, true);
      searchInput.parentNode.querySelector('.reset__button').classList.remove('hidden');
    }
  }

  search(containerSelector, searchText, buttonClick) {
    const containerList = document.querySelectorAll(containerSelector);
    if (containerList.length === 0) return;

    searchText = searchText.trim().toLowerCase();
    let allFiltered = true;

    containerList.forEach((container) => {
      if (!searchText) {
        container.style.display = 'block';
        container.querySelectorAll('.accordion').forEach(el => el.style.display = 'block');
        allFiltered = false;
      } else {
        let sectionFiltered = true;
        container.querySelectorAll('.accordion').forEach((item) => {
          if (item.textContent.toLowerCase().indexOf(searchText) !== -1) {
            item.style.display = 'block';
            allFiltered = false;
            sectionFiltered = false;
          } else {
            item.style.display = 'none';
          }
        });
        
        container.style.display = !sectionFiltered ? 'block' : 'none';

      }
    });

    const noResultsContainer = document.querySelector('.search-no-results');
    if (allFiltered) {
      if (!noResultsContainer) {
        containerList[0].insertAdjacentHTML('beforebegin', '<h3 class="search-no-results" style="font-style: italic; text-align: center; padding: 10rem 0;">No results found</h3>');
      }
    } else if (noResultsContainer) {
      noResultsContainer.remove();
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
  window.stately.textSearch = new TextSearch();
});
